import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function MinusIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M20 12H4" />
    </SvgIcon>
  );
}
